export const GET_PROGRAM_FOR_ATTENDANCE = "GET_PROGRAM_FOR_ATTENDANCE";
export const GET_DATES_FOR_ATTENDANCE = "GET_DATES_FOR_ATTENDANCE";
export const GET_BATCH_VALIDITY_DATE = "GET_BATCH_VALIDITY_DATE";
export const GET_ATTENDANCE_CHECK = "GET_ATTENDANCE_CHECK";
